// src/App.jsx

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import BottomToTop from "./components/BottomToTop";
import MouseFollower from "./components/MouseFollower";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import About from "./pages/About";
import Contact from "./pages/Contact";

import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Refund from "./pages/Refund";

function App() {
  return (
    <Router>
      <div className="flex min-h-screen flex-col bg-white font-[Manrope] text-slate-900">
        {/* =====================================================
            GLOBAL MOUSE FOLLOWER
        ====================================================== */}
        <MouseFollower />

        {/* =====================================================
            NAVBAR
        ====================================================== */}
        <Navbar />

        {/* =====================================================
            PAGE CONTENT
        ====================================================== */}
        <main className="flex-1">
          <Routes>
            {/* =====================================================
                MAIN PAGES
            ====================================================== */}

            <Route path="/" element={<Home />} />

            <Route path="/services" element={<Services />} />

            <Route path="/projects" element={<Projects />} />

            <Route path="/about" element={<About />} />

            <Route path="/contact" element={<Contact />} />

            {/* =====================================================
                LEGAL PAGES
            ====================================================== */}

            <Route path="/privacy" element={<PrivacyPolicy />} />

            <Route path="/terms" element={<Terms />} />

            <Route path="/refund" element={<Refund />} />

            {/* =====================================================
                404 FALLBACK
            ====================================================== */}

            <Route
              path="*"
              element={
                <div className="flex min-h-[60vh] items-center justify-center px-5">
                  <div className="max-w-lg text-center">
                    <p className="text-sm font-extrabold uppercase tracking-[0.2em] text-blue-600">
                      404
                    </p>

                    <h1 className="mt-3 text-4xl font-extrabold tracking-tight text-slate-950 sm:text-5xl">
                      Page Not Found
                    </h1>

                    <p className="mx-auto mt-4 max-w-md text-sm leading-6 text-slate-500 sm:text-base">
                      The page you're looking for doesn't exist or may have
                      been moved.
                    </p>

                    <a
                      href="/"
                      className="mt-7 inline-flex items-center rounded-xl bg-blue-600 px-6 py-3 text-sm font-extrabold text-white shadow-lg shadow-blue-600/20 transition duration-300 hover:-translate-y-1 hover:bg-blue-700 hover:shadow-xl"
                    >
                      Back to Home
                    </a>
                  </div>
                </div>
              }
            />
          </Routes>
        </main>

        {/* =====================================================
            FOOTER
        ====================================================== */}

        <Footer />

        {/* =====================================================
            FLOATING ACTIONS
        ====================================================== */}

        <WhatsAppButton />

        <BottomToTop />
      </div>
    </Router>
  );
}

export default App;